import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';
import { IProduct } from '@frontend/product/types';

import { EquipmentStateName } from './equipment-state';
import { EquipmentTriggerName } from './equipment-trigger';

export interface IEquipment {
    delete_timestamp: string | null;
    serial_number: string;
    state: EquipmentStateName;
    future_state: EquipmentStateName | null;
    workflow_id: string | null;
    owner_id?: string | null;
    user_id?: string | null;
    type: EquipmentType | null;
    update_timestamp: string;
    product_id: string;
    id: string;
    account_id: string;
    creation_timestamp: string;
}

export interface CreateEquipment {
    serial_number: string;
    product_id: string;
    owner_id?: string | null;
    workflow_id?: string | null;
    type?: EquipmentType | null;
}

export interface UpdateEquipment {
    null_fields?: string[] | null;
    serial_number?: string | null;
    state?: EquipmentStateName | null;
    type?: EquipmentType | null;
    future_state?: EquipmentStateName | null;
    workflow_id?: string | null;
    user_id?: string | null;
    owner_id?: string | null;
}

export interface UpdateEquipmentState {
    state?: EquipmentStateName;
}

export interface EquipmentStateTrigger {
    trigger: EquipmentTriggerName;
    source?: any;
    target?: any;
}

export interface EquipmentWithStockLocation extends IEquipment {
    location: { spot_id: string; module_id: string; slot_id: string } | null;
}

export type EquipmentListResponse = PaginatedResponse<IEquipment>;
export type EquipmentWithProduct = IEquipment & {
    product: IProduct;
};
export type EquipmentWithProductListResponse = PaginatedResponse<EquipmentWithProduct>;

enum QueryParams {
    EQUIPMENT_ID = 'equipment_id',
    PRODUCT_ID = 'product_id',
    ACCOUNT_ID = 'account_id',
    USER_ID = 'user_id',
    OWNER_ID = 'owner_id',
    STATE = 'state',
    WORKFLOW_ID = 'workflow_id',
    TYPE = 'type'
}
export type EquipmentQueryParams = QueryParams | DefaultQueryParams;

export enum EquipmentGroupQueryParams {
    GROUP_ID = 'group_id'
}

export enum EquipmentType {
    CONTAINER = 'container',
    LAUNDRY = 'laundry',
    TOOLS = 'tools'
}
